import { DisplayDecorator } from '../decorators/display-decorator';
import { HttpResponseData } from '../interfaces/http-response-data.interface';
import { ODataValueHelperModel, ValueHelperModel } from '../models/low-level/value-helper.model';
import { TextModel } from '../models/primitive/text.model';
import valueHelperJsonData from './ValueHelperSet.json';
export function getValueHelperSetById(id: string): ValueHelperModel[] {
    const valueHelperSet = (valueHelperJsonData as unknown as HttpResponseData<ODataValueHelperModel[]>).d.results;

    return valueHelperSet.filter((valueHelper) => valueHelper.ID === id).map((vh) => ValueHelperModel.fromOData(vh));
}

export function getValueHelpersByIdWithDisplayDecorator(id: string): Array<DisplayDecorator<TextModel>> {
    const valueHelpers = getValueHelperSetById(id);

    return valueHelpers.map((vh) => new DisplayDecorator<TextModel>(vh.descText, new TextModel(vh.descText, vh.code)));
}
